@if (!showPlaceholder) {
  <div class="note-item-wrapper">
    @if (note) {
      <div
        class="note-item"
        [class.note-item-edit]="isEdit"
        [class.note-item-edit-error]="editNoteValue.errors || (error && displayError)"
        [class.single-note]="singleNote"
      >
        @if ({ activeUserId: activeUserId$ | async }; as noteData) {
          <div class="note-content-wrapper">
            <div class="note-header-wrapper">
              <div class="note-header">
                <div class="note-title" [title]="note.createdBy.id | teamMemberName | async">
                  {{ note.createdBy.id | teamMemberName | async }}
                </div>
                @if (note.createdBy.id === noteData.activeUserId && !isEdit) {
                  <div class="note-controls">
                    <button
                      class="note-action-button note-action-button-edit"
                      [disabled]="false | accessControl | async"
                      (click)="onNoteEdit()"
                      title="Edit"
                    >
                      <rkt-icon name="edit"></rkt-icon>
                    </button>
                    <button
                      class="note-action-button note-action-button-delete"
                      [disabled]="false | accessControl | async"
                      (click)="onNoteDelete()"
                      title="Delete"
                    >
                      <rkt-icon name="trash"></rkt-icon>
                    </button>
                  </div>
                }
                @if (note.createdBy.id === noteData.activeUserId && isEdit) {
                  <div class="note-controls">
                    <button class="note-action-button note-item-edit-save" (click)="onNoteEditSave()" title="Save">
                      <rkt-icon name="save"></rkt-icon>
                    </button>
                    <button class="note-action-button note-item-edit-cancel" (click)="onNoteEditCancel()" title="Cancel">
                      <rkt-icon name="times"></rkt-icon>
                    </button>
                  </div>
                }
              </div>
              @if (!singleNote) {
                <div class="note-date" [class.list-note]="!singleNote" [title]="note.createdAt | dateFormat">
                  <div class="note-item-date-text">{{ note.createdAt | dateFormat }}</div>
                </div>
              }
            </div>
            <div class="note-content">
              @if (!isEdit) {
                <div class="note-body">
                  {{ note.contentText }}
                  @if (!isEdit && note.isUpdated) {
                    <span class="note-body-edited" [title]="note.updatedAt | dateFormat">(Edited)</span>
                  }
                </div>
              }
              @if (isEdit) {
                <div class="add-note-field-wrapper">
                  <textarea
                    #noteField
                    class="add-notes-field"
                    (blur)="onNoteFieldBlur()"
                    name="edit-note"
                    id="edit-note"
                    [formControl]="editNoteValue"
                    maxlength="1000"
                  ></textarea>
                  <div class="add-notes-char-count" [class.count-warning]="editNoteValue.value?.length > 800">
                    {{ editNoteValue.value?.length || 0 }}/1000 Characters remaining
                  </div>
                </div>
              }
              @if (attachmentsData.length) {
                <div class="attachment-upload-selected-container">
                  @for (attachment of attachmentsData; track attachment; let i = $index) {
                    <div class="uploaded-attachment-item">
                      <rkt-icon class="attachment-status" name="check"></rkt-icon>
                      <div class="name">{{ attachment.name ?? attachment.file?.name }}</div>
                      <button (click)="onEditFileBtnClick(i)" class="attachment-action-button attachment-action-button-edit">
                        <rkt-icon name="edit"></rkt-icon>
                      </button>
                      <button (click)="onDeleteFileBtnClick(i)" class="attachment-action-button attachment-action-button-delete">
                        <rkt-icon name="trash"></rkt-icon>
                      </button>
                    </div>
                  }
                </div>
              }
              @if (singleNote) {
                <div class="note-date" [title]="note.createdAt | dateFormat">
                  <div class="note-item-date-text">{{ note.createdAt | dateFormat }}</div>
                </div>
              }
            </div>
          </div>
        }
        @if (error && displayError) {
          <div class="note-add-error">{{ error }}</div>
        }
        @if (editNoteValue.errors && editNoteValue.errors.isEmptySpaces) {
          <div class="note-validation-error">
            {{ editNoteValue.errors && editNoteValue.errors.isEmptySpaces.message }}
          </div>
        }
      </div>
    }
    @if (isEdit) {
      <div class="note-attention">Do not enter the card/account details in notes</div>
    }
    @if (isEdit || note.attachments.length) {
      <app-note-item-attachments
        #attachmentsList
        [isEdit]="isEdit"
        [attachments]="note.attachments"
        [entityId]="note.id"
        (addAttachment)="onAddAttachment($event)"
      >
      </app-note-item-attachments>
    }
  </div>
} @else {
  @if (showPlaceholder) {
    <div class="note-item-wrapper">
      <div class="note-item note-item-placeholder" [class.single-note]="singleNote">
        <div class="note-content-wrapper">
          <div class="note-header-wrapper">
            <div class="note-header">
              <div class="note-title"><div class="loading-placeholder"></div></div>
            </div>
          </div>
          <div class="note-content">
            <div class="note-body">
              <div class="loading-placeholder"></div>
              <div class="loading-placeholder"></div>
              <div class="loading-placeholder"></div>
            </div>
            <div class="note-date">
              <div class="note-item-date-text"><div class="loading-placeholder"></div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}
